import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/src/components/container/container.module.css");
